import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import SideBar from "../Components/SideBar.tsx";
import Header from "../Components/Header.tsx";
import "./Home.css";
import { ClientiColumns } from "../lib/ColonneTabelle.ts";
import Tabelle from "../Components/Table.tsx";
import FiltroSidenav from "../Components/FiltroSidenav.tsx";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/Store/index.ts";
import { Committenti } from "../lib/interface.ts";

const tipologiaOptions = [
  { label: "Privato", value: "PRIVATO" },
  { label: "Persona Fisica Titolare di Partita IVA", value: "PFTPI" },
  { label: "Soggetto Diverso da Persona Fisica", value: "SDPF" },
];

const ClientiPage: React.FC = () => {
  const committenti = useSelector(
    (state: RootState) => state.committenti.committenti || []
  );
  const [committentiTable, setCommitTable] = useState<Committenti[]>([]);

  const navigate = useNavigate();
  const [showFiltro, setShowFiltro] = useState(false);

  useEffect(() => {
    const formattedCommittenti = committenti.map((committente) => ({
      ...committente,
      tipologia:
        tipologiaOptions.find(
          (option) => option.value === committente.tipologia
        )?.label || "Non specificato",
      referente: committente.referenti?.[0]
        ? `${committente.referenti[0].nome} ${committente.referenti[0].cognome}`
        : "Nessun referente",
    }));
    setCommitTable(formattedCommittenti);
  }, [committenti]);

  const handleFilterClick = () => {
    setShowFiltro(true);
  };

  const handleAddClick = () => {
    navigate("/crea/committente");
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-between"
      style={{ margin: "0", padding: "0" }}
    >
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna">
        <div className="d-flex justify-content-center">
          <Header
            title="Clienti"
            buttons={[
              { label: "Filtra", onClick: handleFilterClick },
              { label: "Aggiungi un nuovo cliente", onClick: handleAddClick },
            ]}
          />
        </div>

        <div className="d-flex justify-content-center">
          <div className="table-card">
            <Tabelle
              data={committentiTable}
              columns={ClientiColumns}
              type={"committente"}
              tableTitle="Clienti"
            />
          </div>
        </div>
      </Container>

      <FiltroSidenav
        visible={showFiltro}
        onHide={() => setShowFiltro(false)}
        setTable={(c) => setCommitTable(c)}
      />
    </Container>
  );
};

export default ClientiPage;
